// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2f161c5e","692":"4d873637","867":"c22a7631"}[chunkId] + ".chunk.js";
};